
import {IActiveFilter, FilterEnum} from '@app/models';
import { kaseyaProvisioningStateModel, kaseyaWorkflowRequestStateModel } from '@app/helpers';

export function manageFilters(filters?: IActiveFilter[], organizationFilter?: string) {

    let filtersPreparation: string[] = [];
    if (filters && filters.length > 0) {
        filters.map((filter: IActiveFilter) => {
            if (filter.name === FilterEnum.contains) {
                let filterByArray: string[] = filter.filterBy ? filter.filterBy.split(',') : [];
                let containsFilterTemp: string[] = [];

                if (filterByArray.length) {
                    filterByArray.forEach((filterBy: string) => {
                        containsFilterTemp.push(`${filter.name}(${filterBy},'${filter.value}')`);
                    });
                }

                filtersPreparation.push(`(${containsFilterTemp.join(' OR ')})`);
            }
            if (filter.name === FilterEnum.provisioningState && filter.value !== 'Everything') {
                filtersPreparation.push(`${filter.name} eq ${kaseyaProvisioningStateModel}'${filter.value}'`);
            }
            if (filter.name === FilterEnum.groups) {
                filtersPreparation.push(`Groups/any(group: group/Id eq ${filter.value})`);
            }
            if (filter.name === FilterEnum.state && filter.value !== 'Everything') {
                filtersPreparation.push(`${filter.name} eq ${kaseyaWorkflowRequestStateModel}'${filter.value}'`);
            }
            if (filter.name === FilterEnum.categoryId && filter.value !== '0') {
                filtersPreparation.push(`${filter.name} eq ${filter.value}`);
            }
            if (filter.name === FilterEnum.equals) {
                filtersPreparation.push(`${filter.filterBy} eq ${filter.value}`);
            }
            if (filter.name === FilterEnum.cast) {
                filtersPreparation.push(`contains(cast(${filter.filterBy}, 'Edm.String'), '${filter.value}')`);
            }
            if (filter.name === FilterEnum.vaultPasswords) {
                filtersPreparation.push(`Passwords/any(pw: (contains(pw/${filter.filterBy},'${filter.value}') or contains(cast(pw/Id, 'Edm.String'), '${filter.value}')))`);
            }

            if (filter.name === FilterEnum.passwordsList) {
                filtersPreparation.push(`(contains(DisplayName,'${filter.value}') or contains(cast(Id, 'Edm.String'), '${filter.value}'))`);
            }
            if (filter.name === FilterEnum.manualUpdateOnly && filter.value.toLowerCase() === 'yes') {
                filtersPreparation.push('AgentProfileId eq null');
            }
            if (filter.name === FilterEnum.expiredOnly && filter.value.toLowerCase() !== 'no') {
                const currentDate: string = new Date().toISOString();

                filtersPreparation.push(`${filter.filterBy} lt cast(${currentDate},Edm.DateTimeOffset)`);
            }

            return filtersPreparation;
        });
    }
    if (organizationFilter) {
        filtersPreparation.push(`OrganizationId eq ${organizationFilter}`);
    }
    const filtersString: string = filtersPreparation.join(' and ');

    if (filtersString !== '') {
        return filtersString;
    }
}

// The filters for the log page work differently then all the other filters in the application (of course).
// So I'm writing a filter method for the log page

export function manageLogsFilters(filters?: IActiveFilter[]) {
    let filterString: string = '';

    if (filters && filters.length > 0) {
        filters.map((filter: IActiveFilter) => {
            if (filter.name === FilterEnum.contains) {
                filterString += `&filter=${filter.value}`;
            }
            else if (filter.name === FilterEnum.severity && filter.value !== 'Everything') {
                filterString += `&severity=${filter.value}`;
            }
            else if (filter.name === FilterEnum.signinMethod && filter.value !== 'Everything') {
                filterString += `&method=${filter.value}`;
            }
            else if (filter.name === FilterEnum.dateRange) {
                filterString += `${filter.value}`;
            }

            return filterString;
        });
    }

    return filterString;
}


export function manageSearchFilters(filters?: IActiveFilter[]) {
    let filterString: string = '';

    if (filters && filters.length > 0) {
        filters.map((filter: IActiveFilter) => {
            let filterByArray: string[] = filter.filterBy?.split(',') ?? [];
            let filtersTemp: string[] = [];

            if (filterByArray.length) {
                filterByArray.forEach((filterBy: string) => {
                    filtersTemp.push(`indexof(tolower(${filterBy}),tolower('${filter.value}')) gt -1`);
                });
            }

            return filterString = filtersTemp.join(' or ');
        });

    }

    return filterString;
}
